<template>
  <div class="analysis-graph-page col-block">
    <div class="option-container row-block">
      <div class="data-block row-block">
        <template v-if="conditions.filters.product">
          <div><b>品項：</b>{{ getFilterTitle('product') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="conditions.filters.country">
          <div><b>目標市場：</b>{{ getFilterTitle('country') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="dataType === 'country' && conditions.filters.year">
          <div><b>數據年份：</b>{{ getFilterTitle('year') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
        <template v-if="dataType === 'year' && country">
          <div><b>{{ { competitiveness: '競爭國家', attraction: '市場國家', toolcompetitiveness: '競爭國家', toolattraction: '市場國家' }[analysisType] }}：</b>{{ getCountryTitle() }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
      </div>
      <div :style="{ flex: 1 }"></div>
      <div class="option-block row-block">
        <div class="option row-block input-group">
          <div class="option-title">字體</div>
          <div :style="{ width: '8.5px' }"></div>
          <select v-model="fontSize">
            <option value="14">小</option>
            <option value="16">中</option>
            <option value="20">大</option>
          </select>
        </div>
      </div>
      <div :style="{ width: '15px' }"></div>
      <div class="button-block row-block">
        <button type="button" name="button" class="main-button option-button update" @click="e => downloadGraph()">
          <span>另存圖檔</span>
        </button>
      </div>
    </div>
    <div class="content-container" :style="{ flex: 1 }">
      <div class="graph-block row-block stretch">
        <div class="options-container col-block" :style="{ width: '210px' }">
          <div v-if="graphType" class="main-options-block">
            <customFilter
              :init="{ type: graphType }"
              :filters="typeOptions"
              @change="conditions => graphType = conditions.type"
            ></customFilter>
          </div>
          <div class="option-tabs row-block">
            <div class="tab-container" :class="{ active: optionTab === 'graph' }" @click="e => optionTab = 'graph'">
              <div class="tab-block center-block">可調參數</div>
            </div>
            <div class="tab-container" :class="{ active: optionTab === 'data' }" @click="e => optionTab = 'data'">
              <div class="tab-block center-block">數據選擇</div>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div v-if="graphInit" class="sub-options-container" :style="{ flex: 1, height: 0 }">
            <div class="sub-options-block" :class="[optionTab]">
              <customFilter
                v-show="optionTab === 'graph'"
                :init="graphInit"
                :filters="graphOptions"
                @change="conditions => filterOnChange(conditions)"
              ></customFilter>
              <div class="data-select-block col-block" v-show="optionTab === 'data'" :style="{ height: '100%' }">
                <div class="title-container row-block">
                  <div class="title">{{ { country: '國家', year: '年份' }[dataType] }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div :style="{ height: '15px' }"></div>
                <div class="data-lists-container col-block" :style="{ flex: 1, height: 0 }">
                  <div class="data-lists col-block">
                    <label
                      v-for="(data, index) in tableDatas"
                      :key="index"
                      :for="'select_' + {
                        country: {
                          competitiveness: data.country_code,
                          attraction: data.partner_code,
                          toolcompetitiveness: data.country_code,
                          toolattraction: data.partner_code
                        },
                        year: {
                          competitiveness: data.year,
                          attraction: data.year,
                          toolcompetitiveness: data.year,
                          toolattraction: data.year
                        }
                      }[dataType][analysisType]"
                      class="data-block row-block"
                    >
                      <input
                        type="checkbox"
                        v-show="false"
                        :id="'select_' + {
                          country: {
                            competitiveness: data.country_code,
                            attraction: data.partner_code,
                            toolcompetitiveness: data.country_code,
                            toolattraction: data.partner_code
                          },
                          year: {
                            competitiveness: data.year,
                            attraction: data.year,
                            toolcompetitiveness: data.year,
                            toolattraction: data.year
                          }
                        }[dataType][analysisType]"
                        :value="data"
                        v-model="selectedDatas"
                      >
                      <img :src="require('../../assets/images/checkbox-' + (selectedDatas.includes(data) ? 'true' : 'false') + '.svg')">
                      <div :style="{ width: '8px' }"></div>
                      <div
                        class="data-title"
                        :style="{ flex: 1 }"
                        :title="{
                          country: {
                            competitiveness: data.country_name,
                            attraction: data.partner_name,
                            toolcompetitiveness: data.country_name,
                            toolattraction: data.partner_name
                          },
                          year: {
                            competitiveness: data.year,
                            attraction: data.year,
                            toolcompetitiveness: data.year,
                            toolattraction: data.year
                          }
                        }[dataType][analysisType]"
                        v-html="{
                          country: {
                            competitiveness: data.country_name,
                            attraction: data.partner_name,
                            toolcompetitiveness: data.country_name,
                            toolattraction: data.partner_name
                          },
                          year: {
                            competitiveness: data.year,
                            attraction: data.year,
                            toolcompetitiveness: data.year,
                            toolattraction: data.year
                          }
                        }[dataType][analysisType]"
                      ></div>
                    </label>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-if="filterDescription" class="description">
            <div v-html="filterDescription.join('<br>')"></div>
          </div>
          <div :style="{ flex: 1 }"></div> -->
        </div>
        <div class="chart-container" :style="{ flex: 1 }">
          <div class="chart-block">
            <div ref="chartField" class="chart-field" :style="{ '--chart-font-size': fontSize + 'px' }">
              <div class="chart-block col-block">
                <!-- <div class="title">{{ typeOptions.find(option => option.value === 'type').options.find(option => option.value === graphType).title }}</div> -->
                <div class="data-block col-block">
                  <div class="row-block">
                    <div :style="{ flex: 1 }"></div>
                    <div>
                      <b v-html="{
                        country: {
                          competitiveness: [
                            getFilterTitle('year') + '年 ' + getFilterTitle('product'),
                            '在 ' + getFilterTitle('country') + ' 的市場競爭力'
                          ],
                          attraction: [
                            getFilterTitle('year') + '年 ' + getFilterTitle('product'),
                            '各國市場吸引力'
                          ],
                          toolcompetitiveness: [
                            getFilterTitle('year') + '年 ' + getFilterTitle('product'),
                            '在 ' + getFilterTitle('country') + ' 的農業機械市場競爭力'
                          ],
                          toolattraction: [
                            getFilterTitle('year') + '年 ' + getFilterTitle('product'),
                            '各國農業機械市場吸引力'
                          ]
                        },
                        year: {
                          competitiveness: [
                            getCountryTitle() + ' 的 ' + getFilterTitle('product'),
                            '在 ' + getFilterTitle('country') + ' 市場的歷年市場競爭力'
                          ],
                          attraction: [
                            getFilterTitle('product'),
                            '在 ' + getCountryTitle() + ' 的歷年市場吸引力'
                          ],
                          toolcompetitiveness: [
                            getCountryTitle() + ' 的 ' + getFilterTitle('product'),
                            '在 ' + getFilterTitle('country') + ' 市場的歷年農業機械市場競爭力'
                          ],
                          toolattraction: [
                            getFilterTitle('product'),
                            '在 ' + getCountryTitle() + ' 的歷年農業機械市場吸引力'
                          ]
                        }
                      }[dataType][analysisType].join('<br>')"></b>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                  <div class="row-block">
                    <div :style="{ flex: 1 }"></div>
                    <div
                      v-if="filterConditions.point"
                      v-html="'<b>Z軸：</b>' + nco(() => graphOptions.find(option => option.value === 'point').options.find(option => option.value === filterConditions.point).title + (graphOptions.find(option => option.value === 'point').options.find(option => option.value === filterConditions.point).description ? ' (' + graphOptions.find(option => option.value === 'point').options.find(option => option.value === filterConditions.point).description + ')' : '') + (['country'].includes(dataType) ? '<br><b style=\'opacity:0\'>Z軸：</b>( 加權=' + (conditions.weightings[filterConditions.point] ? conditions.weightings[filterConditions.point].active ? conditions.weightings[filterConditions.point].value : 0 : 0) + ' )' : ''), '')"
                      :style="{ 'text-align': 'left' }"
                    ></div>
                  </div>
                  <div class="row-block">
                    <div :style="{ flex: 1 }"></div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="chart-block">
                  <vueCharts
                    v-if="graphType && graphInit && state === 'graph'"
                    ref="chart"
                    :options="chartOptions"
                    :autoresize="true"
                  ></vueCharts>
                </div>
                <div :style="{ flex: 1 }"></div>
                <div class="description-block row-block" :style="{ 'font-size': fontSize + 'px' }">
                  <div :style="{ flex: 1 }"></div>
                  <div class="col-block">
                    <div class="content">資料來源：世界銀行、國際貿易中心、FAOSTAT</div>
                    <div class="title">農業部農業試驗所</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueCharts from 'vue-echarts'
import echarts from 'echarts'
import 'echarts/lib/chart/bar'
import { postAccessLog } from '../../api'
import customFilter from '../tool/customFilter'
import toastMethods from '../../mixins/toastMethods'
import { toPriceString, html2DataUrl, downloadFile, nco } from '../../constants/global/util'

export default {
  components: {
    vueCharts,
    customFilter
  },
  mixins: [
    toastMethods
  ],
  props: {
    dataType: {
      type: String,
      required: true
    },
    country: {
      Type: Object,
      default: () => null
    },
    tableDatas: {
      type: Array,
      required: true
    },
    curSelectedDatas: {
      type: Array,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      echarts: echarts,
      fontSize: '14',
      optionTab: 'graph',
      selectedDatas: [],
      graphInit: null,
      graphType: null,
      displayGraphType: null,
      filterConditions: {}
    }
  },
  computed: {
    graphDatas () {
      let graphDatas = this.selectedDatas
      return graphDatas
    },
    analysisType () {
      return this.$route.name
    },
    // static
    colors () {
      return [
        [
          '#36A2DA',
          '#3966A6',
          '#9CCECB',
          '#85B84F',
          '#3A9171',
          '#29463C',
          '#FFB700',
          '#FF7D0D',
          '#ED92BF',
          '#CC292E',
          '#DABE7F',
          '#6A0E1C',
          '#B38039',
          '#C37FE6'
        ],
        [
          '#85B84F',
          '#FFB700',
          '#ED92BF',
          '#FF7D0D',
          '#36A2DA',
          '#29463C',
          '#CC292E',
          '#C37FE6',
          '#3A9171',
          '#9CCECB',
          '#6A0E1C',
          '#DABE7F',
          '#3966A6',
          '#B38039'
        ]
      ]
    },
    filterDescription () {
      return {
        bar: () => {
          return {
            competitiveness: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            attraction: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            toolcompetitiveness: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            toolattraction: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ]
          }[this.analysisType]
        },
        scatter: () => {
          return {
            competitiveness: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            attraction: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            toolcompetitiveness: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            toolattraction: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ]
          }[this.analysisType]
        },
        bubble: () => {
          return {
            competitiveness: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            attraction: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            toolcompetitiveness: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ],
            toolattraction: [
              '若要修改圖面呈現之國家/年份數據，請回到數據結果勾選操作'
            ]
          }[this.analysisType]
        },
        radar: () => {
          return {
            country: {
              competitiveness: [
                '雷達圖最多提供5個國家疊圖，',
                '若超過國家，顯示前5國家，',
                '若需調整其他年度，請回到',
                '「數據結果」頁面勾選。'
              ],
              attraction: [
                '雷達圖最多提供5個國家疊圖，',
                '若超過國家，顯示前5國家，',
                '若需調整其他年度，請回到',
                '「數據結果」頁面勾選。'
              ],
              toolcompetitiveness: [
                '雷達圖最多提供5個國家疊圖，',
                '若超過國家，顯示前5國家，',
                '若需調整其他年度，請回到',
                '「數據結果」頁面勾選。'
              ],
              toolattraction: [
                '雷達圖最多提供5個國家疊圖，',
                '若超過國家，顯示前5國家，',
                '若需調整其他年度，請回到',
                '「數據結果」頁面勾選。'
              ]
            },
            year: {
              competitiveness: [
                '雷達圖最多提供5個年度疊圖，',
                '若超過則顯示前5個年度，',
                '若需調整其他年度，請回到',
                '「數據結果」頁面勾選。'
              ],
              attraction: [
                '雷達圖最多提供5個年度疊圖，',
                '若超過則顯示前5個年度，',
                '若需調整其他年度，請回到',
                '「數據結果」頁面勾選。'
              ],
              toolcompetitiveness: [
                '雷達圖最多提供5個國家疊圖，',
                '若超過國家，顯示前5國家，',
                '若需調整其他年度，請回到',
                '「數據結果」頁面勾選。'
              ],
              toolattraction: [
                '雷達圖最多提供5個國家疊圖，',
                '若超過國家，顯示前5國家，',
                '若需調整其他年度，請回到',
                '「數據結果」頁面勾選。'
              ]
            }
          }[this.dataType][this.analysisType]
        }
      }[this.graphType]()
    },
    typeOptions () {
      return [
        {
          title: '統計圖類型',
          value: 'type',
          type: 'select',
          options: [
            {
              title: 'XY散佈圖',
              value: 'scatter'
            },
            {
              title: '泡泡圖',
              value: 'bubble'
            },
            {
              title: '累計長條圖',
              value: 'bar'
            },
            {
              title: '雷達圖',
              value: 'radar'
            }
          ]
        }
      ]
    },
    graphOptions () {
      return {
        bar: () => {
          return {
            competitiveness: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  {
                    country: { title: '國家', value: 'country_name' },
                    year: { title: '數據年分', value: 'year' }
                  }[this.dataType]
                ]
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'multiple',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '單位面積產量', value: 'yield' },
                  { title: '生產者價格', value: 'producer_price' },
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' },
                  { title: '市場距離', value: 'distance' }
                ]
              }
            ],
            attraction: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  {
                    country: { title: '國家', value: 'partner_name' },
                    year: { title: '數據年分', value: 'year' }
                  }[this.dataType]
                ]
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'multiple',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '市場規模', value: 'market_size' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '市場距離', value: 'distance' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: '人口數', value: 'total_population' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ]
              }
            ],
            toolcompetitiveness: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  {
                    country: { title: '國家', value: 'country_name' },
                    year: { title: '數據年分', value: 'year' }
                  }[this.dataType]
                ]
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'multiple',
                options: [
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' }
                ]
              }
            ],
            toolattraction: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  {
                    country: { title: '國家', value: 'partner_name' },
                    year: { title: '數據年分', value: 'year' }
                  }[this.dataType]
                ]
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'multiple',
                options: [
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: 'GNI', value: 'GNI' },
                  { title: '農業人口比率', value: 'agricultural_population_proportion' },
                  { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' },
                  { title: '耕地面積', value: 'cultivated_area' },
                  { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ]
              }
            ]
          }[this.analysisType]
        },
        scatter: () => {
          return {
            competitiveness: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '單位面積產量', value: 'yield' },
                  { title: '生產者價格', value: 'producer_price' },
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' },
                  { title: '市場距離', value: 'distance' }
                ].filter(option => option.value !== this.filterConditions.yAxis)
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '單位面積產量', value: 'yield' },
                  { title: '生產者價格', value: 'producer_price' },
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' },
                  { title: '市場距離', value: 'distance' }
                ].filter(option => option.value !== this.filterConditions.xAxis)
              }
            ],
            attraction: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '市場規模', value: 'market_size' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '市場距離', value: 'distance' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: '人口數', value: 'total_population' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ].filter(option => option.value !== this.filterConditions.yAxis)
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '市場規模', value: 'market_size' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '市場距離', value: 'distance' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: '人口數', value: 'total_population' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ].filter(option => option.value !== this.filterConditions.xAxis)
              }
            ],
            toolcompetitiveness: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' }
                ].filter(option => option.value !== this.filterConditions.yAxis)
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'select',
                options: [
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' }
                ].filter(option => option.value !== this.filterConditions.xAxis)
              }
            ],
            toolattraction: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: 'GNI', value: 'GNI' },
                  { title: '農業人口比率', value: 'agricultural_population_proportion' },
                  { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' },
                  { title: '耕地面積', value: 'cultivated_area' },
                  { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ].filter(option => option.value !== this.filterConditions.yAxis)
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'select',
                options: [
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: 'GNI', value: 'GNI' },
                  { title: '農業人口比率', value: 'agricultural_population_proportion' },
                  { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' },
                  { title: '耕地面積', value: 'cultivated_area' },
                  { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ].filter(option => option.value !== this.filterConditions.xAxis)
              }
            ]
          }[this.analysisType]
        },
        bubble: () => {
          return {
            competitiveness: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '單位面積產量', value: 'yield' },
                  { title: '生產者價格', value: 'producer_price' },
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' },
                  { title: '市場距離', value: 'distance' }
                ].filter(option => ![this.filterConditions.yAxis, this.filterConditions.point].includes(option.value))
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '單位面積產量', value: 'yield' },
                  { title: '生產者價格', value: 'producer_price' },
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' },
                  { title: '市場距離', value: 'distance' }
                ].filter(option => ![this.filterConditions.xAxis, this.filterConditions.point].includes(option.value))
              },
              {
                title: 'Z軸',
                value: 'point',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity', description: '公噸' },
                  { title: '單位面積產量', value: 'yield', description: '百克/公頃' },
                  { title: '生產者價格', value: 'producer_price', description: '美元/公噸' },
                  { title: '進口單價', value: 'import_price', description: '美元/公斤' },
                  { title: 'RCA', value: 'RCA', description: '' },
                  { title: 'TII', value: 'TII', description: '' },
                  { title: '市場距離', value: 'distance', description: '公里' }
                ].filter(option => ![this.filterConditions.xAxis, this.filterConditions.yAxis].includes(option.value))
              }
            ],
            attraction: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '市場規模', value: 'market_size' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '市場距離', value: 'distance' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: '人口數', value: 'total_population' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ].filter(option => ![this.filterConditions.yAxis, this.filterConditions.point].includes(option.value))
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '市場規模', value: 'market_size' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '市場距離', value: 'distance' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: '人口數', value: 'total_population' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ].filter(option => ![this.filterConditions.xAxis, this.filterConditions.point].includes(option.value))
              },
              {
                title: 'Z軸',
                value: 'point',
                type: 'select',
                options: [
                  { title: '產量', value: 'production_quantity', description: '公噸' },
                  { title: '出口值', value: 'export_value', description: '千美元' },
                  { title: '進口值', value: 'import_value', description: '千美元' },
                  { title: '市場規模', value: 'market_size', description: '千美元' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend', description: '%' },
                  { title: 'TSI', value: 'TSI', description: '' },
                  { title: '市場距離', value: 'distance', description: '公里' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share', description: '%' },
                  { title: '平均每人GDP', value: 'GDP', description: '美元' },
                  { title: '人口數', value: 'total_population', description: '' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity', description: '%' },
                  { title: '進口市場表現', value: 'market_performance', description: '%' },
                  { title: '市場開放程度', value: 'market_openness', description: '%' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff', description: '%' }
                ].filter(option => ![this.filterConditions.xAxis, this.filterConditions.yAxis].includes(option.value))
              }
            ],
            toolcompetitiveness: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' }
                ].filter(option => ![this.filterConditions.yAxis, this.filterConditions.point].includes(option.value))
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'select',
                options: [
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' }
                ].filter(option => ![this.filterConditions.xAxis, this.filterConditions.point].includes(option.value))
              },
              {
                title: 'Z軸',
                value: 'point',
                type: 'select',
                options: [
                  { title: '進口單價', value: 'import_price', description: '美元/公斤' },
                  { title: 'RCA', value: 'RCA', description: '' },
                  { title: 'TII', value: 'TII', description: '' }
                ].filter(option => ![this.filterConditions.xAxis, this.filterConditions.yAxis].includes(option.value))
              }
            ],
            toolattraction: [
              {
                title: 'X軸',
                value: 'xAxis',
                type: 'select',
                options: [
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: 'GNI', value: 'GNI' },
                  { title: '農業人口比率', value: 'agricultural_population_proportion' },
                  { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' },
                  { title: '耕地面積', value: 'cultivated_area' },
                  { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ].filter(option => ![this.filterConditions.yAxis, this.filterConditions.point].includes(option.value))
              },
              {
                title: 'Y軸',
                value: 'yAxis',
                type: 'select',
                options: [
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: 'GNI', value: 'GNI' },
                  { title: '農業人口比率', value: 'agricultural_population_proportion' },
                  { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' },
                  { title: '耕地面積', value: 'cultivated_area' },
                  { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ].filter(option => ![this.filterConditions.xAxis, this.filterConditions.point].includes(option.value))
              },
              {
                title: 'Z軸',
                value: 'point',
                type: 'select',
                options: [
                  { title: '出口值', value: 'export_value', description: '千美元' },
                  { title: '進口值', value: 'import_value', description: '千美元' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend', description: '%' },
                  { title: 'TSI', value: 'TSI', description: '' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share', description: '%' },
                  { title: '平均每人GDP', value: 'GDP', description: '美元' },
                  { title: 'GNI', value: 'GNI', description: '美元' },
                  { title: '農業人口比率', value: 'agricultural_population_proportion', description: '%' },
                  { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend', description: '%' },
                  { title: '耕地面積', value: 'cultivated_area', description: '平方公里' },
                  { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area', description: '平方公里/人' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity', description: '%' },
                  { title: '進口市場表現', value: 'market_performance', description: '%' },
                  { title: '市場開放程度', value: 'market_openness', description: '%' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff', description: '%' }
                ].filter(option => ![this.filterConditions.xAxis, this.filterConditions.yAxis].includes(option.value))
              }
            ]
          }[this.analysisType]
        },
        radar: () => {
          return {
            competitiveness: [
              {
                title: '維度（可選擇3-8項維度）',
                value: 'dimension',
                type: 'multiple',
                range: [3, 8],
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '單位面積產量', value: 'yield' },
                  { title: '生產者價格', value: 'producer_price' },
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' },
                  { title: '市場距離', value: 'distance' }
                ]
              }
            ],
            attraction: [
              {
                title: '維度（可選擇3-8項維度）',
                value: 'dimension',
                type: 'multiple',
                range: [3, 8],
                options: [
                  { title: '產量', value: 'production_quantity' },
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '市場規模', value: 'market_size' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '市場距離', value: 'distance' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: '人口數', value: 'total_population' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ]
              }
            ],
            toolcompetitiveness: [
              {
                title: '維度（可選擇3-8項維度）',
                value: 'dimension',
                type: 'multiple',
                range: [3, 8],
                options: [
                  { title: '進口單價', value: 'import_price' },
                  { title: 'RCA', value: 'RCA' },
                  { title: 'TII', value: 'TII' }
                ]
              }
            ],
            toolattraction: [
              {
                title: '維度（可選擇3-8項維度）',
                value: 'dimension',
                type: 'multiple',
                range: [3, 8],
                options: [
                  { title: '出口值', value: 'export_value' },
                  { title: '進口值', value: 'import_value' },
                  { title: '進口市場成長趨勢', value: 'import_market_growth_trend' },
                  { title: 'TSI', value: 'TSI' },
                  { title: '佔全球貿易市場佔有率', value: 'market_share' },
                  { title: '平均每人GDP', value: 'GDP' },
                  { title: 'GNI', value: 'GNI' },
                  { title: '農業人口比率', value: 'agricultural_population_proportion' },
                  { title: '農業人口比率趨勢', value: 'agricultural_population_proportion_trend' },
                  { title: '耕地面積', value: 'cultivated_area' },
                  { title: '平均農業人口耕地面積', value: 'average_agricultural_population_cultivated_area' },
                  { title: '市場成長相對強度', value: 'market_growth_intensity' },
                  { title: '進口市場表現', value: 'market_performance' },
                  { title: '市場開放程度', value: 'market_openness' },
                  { title: '市場相對優惠關稅', value: 'market_preferential_tariff' }
                ]
              }
            ]
          }[this.analysisType]
        }
      }[this.graphType]()
    },
    chartOptions () {
      return {
        bar: () => {
          let datas = {
            competitiveness: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            attraction: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            toolcompetitiveness: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            toolattraction: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            }
          }[this.analysisType]()
          let columnMap = {
            competitiveness: {
              production_quantity: {
                title: '產量',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              yield: {
                title: '單位面積產量',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              producer_price: {
                title: '生產者價格',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              import_price: {
                title: '進口單價',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              RCA: {
                title: 'RCA',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              TII: {
                title: 'TII',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              distance: {
                title: '市場距離',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              }
            },
            attraction: {
              production_quantity: {
                title: '產量',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              export_value: {
                title: '出口值',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              import_value: {
                title: '進口值',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_size: {
                title: '市場規模',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              TSI: {
                title: 'TSI',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              distance: {
                title: '市場距離',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              GDP: {
                title: '平均每人GDP',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              total_population: {
                title: '人口數',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_performance: {
                title: '進口市場表現',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_openness: {
                title: '市場開放程度',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              }
            },
            toolcompetitiveness: {
              import_price: {
                title: '進口單價',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              RCA: {
                title: 'RCA',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              TII: {
                title: 'TII',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              }
            },
            toolattraction: {
              export_value: {
                title: '出口值',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              import_value: {
                title: '進口值',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              TSI: {
                title: 'TSI',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              GDP: {
                title: '平均每人GDP',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              GNI: {
                title: 'GNI',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              agricultural_population_proportion: {
                title: '農業人口比率',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              agricultural_population_proportion_trend: {
                title: '農業人口比率趨勢',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              cultivated_area: {
                title: '耕地面積',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              average_agricultural_population_cultivated_area: {
                title: '平均農業人口耕地面積',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_performance: {
                title: '進口市場表現',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_openness: {
                title: '市場開放程度',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                display: data => data ? data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '') : ''
              }
            }
          }[this.analysisType]
          const graphChartOptions = {
            color: this.colors[1],
            legend: {
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 20,
              bottom: 10,
              data: (this.filterConditions.yAxis || []).filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).title + ' (' + (this.conditions.weightings[value].active ? this.conditions.weightings[value].value : 0) + ')'),
              textStyle: {
                fontSize: this.fontSize
              }
            },
            xAxis: {
              type: 'category',
              data: datas.map(data => ({
                country: data[this.filterConditions.xAxis],
                year: data[this.filterConditions.xAxis] + '年'
              }[this.dataType])),
              nameTextStyle: {
                fontSize: this.fontSize
              },
              axisLabel: {
                rotate: {
                  country: { competitiveness: -70, attraction: -70, toolcompetitiveness: -70, toolattraction: -70 },
                  year: { competitiveness: -70, attraction: -70, toolcompetitiveness: -70, toolattraction: -70 }
                }[this.dataType][this.analysisType],
                fontSize: this.fontSize
              }
            },
            yAxis: {
              type: 'value',
              name: '標準化分數總計',
              nameLocation: 'middle',
              nameGap: 40,
              nameTextStyle: {
                fontSize: this.fontSize
              },
              axisLabel: {
                fontSize: this.fontSize
              }
            },
            grid: {
              top: 30,
              left: 50,
              right: { competitiveness: 150, attraction: 200, toolcompetitiveness: 150, toolattraction: 200 }[this.analysisType] + ((this.fontSize / 14 - 0.9) * 180),
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              textStyle: {
                fontSize: this.fontSize
              }
            },
            series: this.filterConditions.yAxis.filter(value => this.conditions.weightings[value]).map(value => ({
              name: (columnMap[value] || {}).title + ' (' + (this.conditions.weightings[value].active ? this.conditions.weightings[value].value : 0) + ')',
              type: 'bar',
              stack: 'default',
              barCategoryGap: '60%',
              data: datas.map(data => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || 0)
            }))
          }
          return graphChartOptions
        },
        scatter: () => {
          let datas = {
            competitiveness: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            attraction: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            toolcompetitiveness: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            toolattraction: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            }
          }[this.analysisType]()
          let columnMap = {
            competitiveness: {
              production_quantity: {
                title: '產量',
                description: '公噸'
              },
              yield: {
                title: '單位面積產量',
                description: '百克/公頃'
              },
              producer_price: {
                title: '生產者價格',
                description: '美元/公噸'
              },
              import_price: {
                title: '進口單價',
                description: '美元/公斤'
              },
              RCA: {
                title: 'RCA',
                description: ''
              },
              TII: {
                title: 'TII',
                description: ''
              },
              distance: {
                title: '市場距離',
                description: '公里'
              }
            },
            attraction: {
              production_quantity: {
                title: '產量',
                description: '公噸'
              },
              export_value: {
                title: '出口值',
                description: '千美元'
              },
              import_value: {
                title: '進口值',
                description: '千美元'
              },
              market_size: {
                title: '市場規模',
                description: '千美元'
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                description: '%'
              },
              TSI: {
                title: 'TSI',
                description: ''
              },
              distance: {
                title: '市場距離',
                description: '公里'
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                description: '%'
              },
              GDP: {
                title: '平均每人GDP',
                description: '美元'
              },
              total_population: {
                title: '人口數',
                description: ''
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                description: '%'
              },
              market_performance: {
                title: '進口市場表現',
                description: '%'
              },
              market_openness: {
                title: '市場開放程度',
                description: '%'
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                description: '%'
              }
            },
            toolcompetitiveness: {
              import_price: {
                title: '進口單價',
                description: '美元/公斤'
              },
              RCA: {
                title: 'RCA',
                description: ''
              },
              TII: {
                title: 'TII',
                description: ''
              }
            },
            toolattraction: {
              export_value: {
                title: '出口值',
                description: '千美元'
              },
              import_value: {
                title: '進口值',
                description: '千美元'
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                description: '%'
              },
              TSI: {
                title: 'TSI',
                description: ''
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                description: '%'
              },
              GDP: {
                title: '平均每人GDP',
                description: '美元'
              },
              GNI: {
                title: 'GNI',
                description: '美元'
              },
              agricultural_population_proportion: {
                title: '農業人口比率',
                description: '%'
              },
              agricultural_population_proportion_trend: {
                title: '農業人口比率趨勢',
                description: '%'
              },
              cultivated_area: {
                title: '耕地面積',
                description: '平方公里'
              },
              average_agricultural_population_cultivated_area: {
                title: '平均農業人口耕地面積',
                description: '平方公里/人'
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                description: '%'
              },
              market_performance: {
                title: '進口市場表現',
                description: '%'
              },
              market_openness: {
                title: '市場開放程度',
                description: '%'
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                description: '%'
              }
            }
          }[this.analysisType]
          let yAxisValueLength = Math.max(3, ((Math.max.apply(null, datas.map(data => data[this.filterConditions.yAxis])).toFixed(0) || 999) + '0').length)
          const graphChartOptions = {
            color: this.colors[1],
            xAxis: {
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              name: (columnMap[this.filterConditions.xAxis] || {}).title + ((columnMap[this.filterConditions.xAxis] || {}).description ? '(' + (columnMap[this.filterConditions.xAxis] || {}).description + ')' : '') + (['country'].includes(this.dataType) ? ' ( 加權=' + (this.conditions.weightings[this.filterConditions.xAxis] ? this.conditions.weightings[this.filterConditions.xAxis].active ? this.conditions.weightings[this.filterConditions.xAxis].value : 0 : 0) + ' )' : ''),
              nameLocation: 'middle',
              nameGap: 40,
              nameTextStyle: {
                fontSize: this.fontSize
              },
              axisLabel: {
                fontSize: this.fontSize
              }
            },
            yAxis: {
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              name: (columnMap[this.filterConditions.yAxis] || {}).title + ((columnMap[this.filterConditions.yAxis] || {}).description ? '(' + (columnMap[this.filterConditions.yAxis] || {}).description + ')' : '') + (['country'].includes(this.dataType) ? ' ( 加權=' + (this.conditions.weightings[this.filterConditions.yAxis] ? this.conditions.weightings[this.filterConditions.yAxis].active ? this.conditions.weightings[this.filterConditions.yAxis].value : 0 : 0) + ' )' : ''),
              nameLocation: 'middle',
              nameGap: yAxisValueLength * 10 * (this.fontSize / 14),
              nameTextStyle: {
                fontSize: this.fontSize
              },
              axisLabel: {
                fontSize: this.fontSize
              },
              scale: true
            },
            grid: {
              top: 80,
              left: 40 + yAxisValueLength * 10 * (this.fontSize / 14),
              right: 80,
              bottom: 120
            },
            series: datas.map(data => ({
              type: 'scatter',
              symbolSize: function (data) {
                return Math.sqrt(data[2])
              },
              label: {
                normal: {
                  show: true,
                  formatter: param => param.data[3],
                  textShadowBlur: 2,
                  textShadowColor: 'rgba(0, 0, 0, 0.2)',
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                  textStyle: {
                    fontSize: this.fontSize
                  },
                  position: 'bottom'
                },
                emphasis: {
                  show: true,
                  formatter: param => param.data[3],
                  backgroundColor: 'white',
                  borderRadius: 999999999999999,
                  borderColor: '#cccccc',
                  borderWidth: 1,
                  padding: [5, 10],
                  shadowBlur: 6,
                  shadowColor: 'rgba(0, 0, 0, 0.2)',
                  shadowOffsetX: 3,
                  shadowOffsetY: 3,
                  textShadowColor: 'rgba(0, 0, 0, 0)',
                  position: 'bottom'
                }
              },
              itemStyle: {
                normal: {
                  shadowBlur: 6,
                  shadowColor: 'rgba(0, 0, 0, 0.2)',
                  shadowOffsetX: 3,
                  shadowOffsetY: 3,
                  opacity: 0.8
                },
                emphasis: {
                  opacity: 1
                }
              },
              data: [data].map(data => [
                data[this.filterConditions.xAxis] || 0,
                data[this.filterConditions.yAxis] || 0,
                200,
                {
                  country: {
                    competitiveness: data.country_name,
                    attraction: data.partner_name,
                    toolcompetitiveness: data.country_name,
                    toolattraction: data.partner_name
                  },
                  year: {
                    competitiveness: data.year + '年',
                    attraction: data.year + '年',
                    toolcompetitiveness: data.year + '年',
                    toolattraction: data.year + '年'
                  }
                }[this.dataType][this.analysisType]
              ])
            }))
          }
          return graphChartOptions
        },
        bubble: () => {
          let datas = {
            competitiveness: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            attraction: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            toolcompetitiveness: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            },
            toolattraction: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType]
              return _datas
            }
          }[this.analysisType]()
          let columnMap = {
            competitiveness: {
              production_quantity: {
                title: '產量',
                description: '公噸',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              yield: {
                title: '單位面積產量',
                description: '百克/公頃',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              producer_price: {
                title: '生產者價格',
                description: '美元/公噸',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_price: {
                title: '進口單價',
                description: '美元/公斤',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              RCA: {
                title: 'RCA',
                description: '',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              TII: {
                title: 'TII',
                description: '',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              distance: {
                title: '市場距離',
                description: '公里',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              }
            },
            attraction: {
              production_quantity: {
                title: '產量',
                description: '公噸',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              export_value: {
                title: '出口值',
                description: '千美元',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_value: {
                title: '進口值',
                description: '千美元',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_size: {
                title: '市場規模',
                description: '千美元',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              TSI: {
                title: 'TSI',
                description: '',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              distance: {
                title: '市場距離',
                description: '公里',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              GDP: {
                title: '平均每人GDP',
                description: '美元',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              total_population: {
                title: '人口數',
                description: '',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_performance: {
                title: '進口市場表現',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_openness: {
                title: '市場開放程度',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              }
            },
            toolcompetitiveness: {
              import_price: {
                title: '進口單價',
                description: '美元/公斤',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              RCA: {
                title: 'RCA',
                description: '',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              TII: {
                title: 'TII',
                description: '',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              }
            },
            toolattraction: {
              export_value: {
                title: '出口值',
                description: '千美元',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_value: {
                title: '進口值',
                description: '千美元',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              TSI: {
                title: 'TSI',
                description: '',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              GDP: {
                title: '平均每人GDP',
                description: '美元',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              GNI: {
                title: 'GNI',
                description: '美元',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              agricultural_population_proportion: {
                title: '農業人口比率',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              agricultural_population_proportion_trend: {
                title: '農業人口比率趨勢',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              cultivated_area: {
                title: '耕地面積',
                description: '平方公里',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              average_agricultural_population_cultivated_area: {
                title: '平均農業人口耕地面積',
                description: '平方公里/人',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_performance: {
                title: '進口市場表現',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_openness: {
                title: '市場開放程度',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                description: '%',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              }
            }
          }[this.analysisType]
          // let sizeScale = 5000 / Math.min.apply(null, datas.map(data => Math.abs(data[this.filterConditions.point])).filter(data => data))
          let max = Math.max.apply(null, datas.map(data => Math.abs(data[this.filterConditions.point])).filter(data => data || data === 0))
          let min = Math.min.apply(null, datas.map(data => Math.abs(data[this.filterConditions.point])).filter(data => data || data === 0))
          let yAxisValueLength = Math.max(3, ((Math.max.apply(null, datas.map(data => data[this.filterConditions.yAxis])).toFixed(0) || 999) + '0').length)
          const graphChartOptions = {
            color: this.colors[1],
            xAxis: {
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              name: (columnMap[this.filterConditions.xAxis] || {}).title + ((columnMap[this.filterConditions.xAxis] || {}).description ? '(' + (columnMap[this.filterConditions.xAxis] || {}).description + ')' : '') + (['country'].includes(this.dataType) ? ' ( 加權=' + (this.conditions.weightings[this.filterConditions.xAxis] ? this.conditions.weightings[this.filterConditions.xAxis].active ? this.conditions.weightings[this.filterConditions.xAxis].value : 0 : 0) + ' )' : ''),
              nameLocation: 'middle',
              nameGap: 40,
              nameTextStyle: {
                fontSize: this.fontSize
              },
              axisLabel: {
                fontSize: this.fontSize
              }
            },
            yAxis: {
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              name: (columnMap[this.filterConditions.yAxis] || {}).title + ((columnMap[this.filterConditions.yAxis] || {}).description ? '(' + (columnMap[this.filterConditions.yAxis] || {}).description + ')' : '') + (['country'].includes(this.dataType) ? ' ( 加權=' + (this.conditions.weightings[this.filterConditions.yAxis] ? this.conditions.weightings[this.filterConditions.yAxis].active ? this.conditions.weightings[this.filterConditions.xAxis].value : 0 : 0) + ' )' : ''),
              nameLocation: 'middle',
              nameGap: yAxisValueLength * 10 * (this.fontSize / 14),
              nameTextStyle: {
                fontSize: this.fontSize
              },
              axisLabel: {
                fontSize: this.fontSize
              },
              scale: true
            },
            grid: {
              top: 80,
              left: Math.max(120, 40 + yAxisValueLength * 10 * (this.fontSize / 14)),
              right: 80,
              bottom: 120
            },
            series: [...datas].sort((a, b) => Math.abs(b[this.filterConditions.point]) - Math.abs(a[this.filterConditions.point])).map(data => ({
              type: 'scatter',
              symbolSize: function (data) {
                let size = max - min ? (Math.abs(data[2]) - min) / (max - min) : 0.0001
                return 100 * Math.sqrt(Math.sqrt(size)) + 10
              },
              label: {
                normal: {
                  show: true,
                  formatter: param => param.data[3] + '\n' + ((columnMap[this.filterConditions.point] || {}).display(param.data[2]) || 0),
                  textShadowBlur: 2,
                  textShadowColor: 'rgba(0, 0, 0, 0.2)',
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                  textStyle: {
                    fontSize: this.fontSize
                  },
                  position: 'bottom'
                },
                emphasis: {
                  show: true,
                  formatter: param => param.data[3] + '\n' + ((columnMap[this.filterConditions.point] || {}).display(param.data[2]) || 0),
                  backgroundColor: 'white',
                  borderRadius: 999999999999999,
                  borderColor: '#cccccc',
                  borderWidth: 1,
                  padding: [5, 10],
                  shadowBlur: 6,
                  shadowColor: 'rgba(0, 0, 0, 0.2)',
                  shadowOffsetX: 3,
                  shadowOffsetY: 3,
                  textShadowColor: 'rgba(0, 0, 0, 0)',
                  position: 'bottom'
                }
              },
              itemStyle: {
                normal: {
                  shadowBlur: 6,
                  shadowColor: 'rgba(0, 0, 0, 0.2)',
                  shadowOffsetX: 3,
                  shadowOffsetY: 3,
                  opacity: 0.6,
                  color: param => {
                    return (
                      !param.data[2] ? '#999999'
                      : param.data[2] < 0 ? '#999999'
                      : this.colors[1][param.seriesIndex % this.colors[1].length]
                    )
                  }
                },
                emphasis: {
                  opacity: 1
                }
              },
              data: [data].map(data => [
                data[this.filterConditions.xAxis] || 0,
                data[this.filterConditions.yAxis] || 0,
                data[this.filterConditions.point] || 0,
                {
                  country: {
                    competitiveness: data.country_name,
                    attraction: data.partner_name,
                    toolcompetitiveness: data.country_name,
                    toolattraction: data.partner_name
                  },
                  year: {
                    competitiveness: data.year + '年',
                    attraction: data.year + '年',
                    toolcompetitiveness: data.year + '年',
                    toolattraction: data.year + '年'
                  }
                }[this.dataType][this.analysisType]
              ])
            }))
          }
          return graphChartOptions
        },
        radar: () => {
          let datas = {
            competitiveness: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType].slice(0, 5)
              return _datas
            },
            attraction: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType].slice(0, 5)
              return _datas
            },
            toolcompetitiveness: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType].slice(0, 5)
              return _datas
            },
            toolattraction: () => {
              let _datas = {
                country: [...this.graphDatas],
                year: [...this.graphDatas].reverse()
              }[this.dataType].slice(0, 5)
              return _datas
            }
          }[this.analysisType]()
          let columnMap = {
            competitiveness: {
              production_quantity: {
                title: '產量',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              yield: {
                title: '單位面積產量',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              producer_price: {
                title: '生產者價格',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_price: {
                title: '進口單價',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              RCA: {
                title: 'RCA',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              TII: {
                title: 'TII',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              distance: {
                title: '市場距離',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              }
            },
            attraction: {
              production_quantity: {
                title: '產量',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              export_value: {
                title: '出口值',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_value: {
                title: '進口值',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_size: {
                title: '市場規模',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              TSI: {
                title: 'TSI',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              distance: {
                title: '市場距離',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              GDP: {
                title: '平均每人GDP',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              total_population: {
                title: '人口數',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_performance: {
                title: '進口市場表現',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_openness: {
                title: '市場開放程度',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              }
            },
            toolcompetitiveness: {
              import_price: {
                title: '進口單價',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              RCA: {
                title: 'RCA',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              TII: {
                title: 'TII',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              }
            },
            toolattraction: {
              export_value: {
                title: '出口值',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_value: {
                title: '進口值',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              import_market_growth_trend: {
                title: '進口市場成長趨勢',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              TSI: {
                title: 'TSI',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_share: {
                title: '佔全球貿易市場佔有率',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              GDP: {
                title: '平均每人GDP',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              GNI: {
                title: 'GNI',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              agricultural_population_proportion: {
                title: '農業人口比率',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              agricultural_population_proportion_trend: {
                title: '農業人口比率趨勢',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              cultivated_area: {
                title: '耕地面積',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              average_agricultural_population_cultivated_area: {
                title: '平均農業人口耕地面積',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_growth_intensity: {
                title: '市場成長相對強度',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_performance: {
                title: '進口市場表現',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_openness: {
                title: '市場開放程度',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              },
              market_preferential_tariff: {
                title: '市場相對優惠關稅',
                display: data => data ? toPriceString(data.toFixed(3).replace(/(?!.*[.1-9]).+$|\.0+$/, '')) : ''
              }
            }
          }[this.analysisType]
          const graphChartOptions = {
            color: this.colors[1],
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 20,
              bottom: 10,
              data: datas.map(data => ({
                country: {
                  competitiveness: data.country_name,
                  attraction: data.partner_name,
                  toolcompetitiveness: data.country_name,
                  toolattraction: data.partner_name
                },
                year: {
                  competitiveness: data.year + '年',
                  attraction: data.year + '年',
                  toolcompetitiveness: data.year + '年',
                  toolattraction: data.year + '年'
                }
              }[this.dataType][this.analysisType])),
              textStyle: {
                fontSize: this.fontSize
              }
            },
            radar: {
              name: {
                textStyle: {
                  color: '#555555',
                  fontSize: this.fontSize,
                  padding: [3, 5]
                }
              },
              indicator: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => ({
                name: (columnMap[value] || {}).title,
                max: 5 * this.conditions.weightings[value].value
              })),
              center: ['45%', '50%'],
              radius: '70%'
            },
            series: [
              {
                type: 'radar',
                symbolSize: 10,
                tooltip: {
                  trigger: 'item'
                },
                itemStyle: {
                  normal: {
                    areaStyle: {
                      type: 'default',
                      opacity: 0.3
                    }
                  },
                  emphasis: {
                    areaStyle: {
                      type: 'default',
                      opacity: 0.9
                    }
                  }
                },
                data: datas.map(data => ({
                  country: {
                    competitiveness: {
                      name: data.country_name,
                      value: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || '0')
                    },
                    attraction: {
                      name: data.partner_name,
                      value: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || '0')
                    },
                    toolcompetitiveness: {
                      name: data.country_name,
                      value: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || '0')
                    },
                    toolattraction: {
                      name: data.partner_name,
                      value: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || '0')
                    }
                  },
                  year: {
                    competitiveness: {
                      name: data.year + '年',
                      value: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || '0')
                    },
                    attraction: {
                      name: data.year + '年',
                      value: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || '0')
                    },
                    toolcompetitiveness: {
                      name: data.year + '年',
                      value: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || '0')
                    },
                    toolattraction: {
                      name: data.year + '年',
                      value: this.filterConditions.dimension.filter(value => this.conditions.weightings[value]).map(value => (columnMap[value] || {}).display({ country: data.display_standardization[value], year: data.standardization[value] }[this.dataType]) || '0')
                    }
                  }
                }[this.dataType][this.analysisType]))
              }
            ]
          }
          return graphChartOptions
        }
      }[this.displayGraphType || this.graphType]()
    },
    // global
    nco () { return nco }
  },
  created () {
    this.graphType = 'scatter'
    this.selectedDatas = [...this.curSelectedDatas]
  },
  watch: {
    'graphType' (nv, ov) {
      this.graphInit = {
        bar: () => {
          return {
            competitiveness: {
              xAxis: {
                country: 'country_name',
                year: 'year'
              }[this.dataType],
              yAxis: [
                'production_quantity',
                'yield',
                'producer_price',
                'import_price',
                'RCA',
                'TII',
                'distance'
              ]
            },
            attraction: {
              xAxis: {
                country: 'partner_name',
                year: 'year'
              }[this.dataType],
              yAxis: [
                'production_quantity',
                'export_value',
                'import_value',
                'market_size',
                'import_market_growth_trend',
                'TSI',
                'distance',
                'market_share',
                'GDP',
                'total_population',
                'market_growth_intensity',
                'market_performance',
                'market_openness',
                'market_preferential_tariff'
              ]
            },
            toolcompetitiveness: {
              xAxis: {
                country: 'country_name',
                year: 'year'
              }[this.dataType],
              yAxis: [
                'import_price',
                'RCA',
                'TII'
              ]
            },
            toolattraction: {
              xAxis: {
                country: 'partner_name',
                year: 'year'
              }[this.dataType],
              yAxis: [
                'export_value',
                'import_value',
                'import_market_growth_trend',
                'TSI',
                'market_share',
                'GDP',
                'GNI',
                'agricultural_population_proportion',
                'agricultural_population_proportion_trend',
                'cultivated_area',
                'average_agricultural_population_cultivated_area',
                'market_growth_intensity',
                'market_performance',
                'market_openness',
                'market_preferential_tariff'
              ]
            }
          }[this.analysisType]
        },
        scatter: () => {
          return {
            competitiveness: {
              point: 'country_name',
              xAxis: 'production_quantity',
              yAxis: 'yield'
            },
            attraction: {
              point: 'partner_name',
              xAxis: 'production_quantity',
              yAxis: 'export_value'
            },
            toolcompetitiveness: {
              point: 'import_price',
              xAxis: 'TII',
              yAxis: 'import_price'
            },
            toolattraction: {
              point: 'partner_name',
              xAxis: 'import_value',
              yAxis: 'export_value'
            }
          }[this.analysisType]
        },
        bubble: () => {
          return {
            competitiveness: {
              point: 'production_quantity',
              xAxis: 'RCA',
              yAxis: 'RCA'
            },
            attraction: {
              point: 'production_quantity',
              xAxis: 'export_value',
              yAxis: 'import_value'
            },
            toolcompetitiveness: {
              point: 'import_price',
              xAxis: 'TII',
              yAxis: 'import_price'
            },
            toolattraction: {
              point: 'import_market_growth_trend',
              xAxis: 'import_value',
              yAxis: 'export_value'
            }
          }[this.analysisType]
        },
        radar: () => {
          return {
            competitiveness: {
              dimension: [
                'production_quantity',
                'yield',
                'producer_price',
                'import_price',
                'RCA'
              ]
            },
            attraction: {
              dimension: [
                'production_quantity',
                'export_value',
                'import_value',
                'market_size',
                'import_market_growth_trend'
              ]
            },
            toolcompetitiveness: {
              dimension: [
                'import_price',
                'RCA',
                'TII'
              ]
            },
            toolattraction: {
              dimension: [
                'export_value',
                'import_value',
                'import_market_growth_trend',
                'TSI',
                'market_share'
              ]
            }
          }[this.analysisType]
        }
      }[nv]()
    },
    'curSelectedDatas' (nv) {
      this.selectedDatas = [...nv]
    },
    'selectedDatas' (nv, ov) {
      if (nv.length !== ov.length) {
        this.$emit('dataChange', this.tableDatas.filter(data => this.selectedDatas.includes(data)))
      }
    }
  },
  methods: {
    getFilterTitle (value) {
      if (!this.conditions.filters[value]) {
        return ''
      }
      return this.filterOptions.filters.find(filter => filter.value === value).options.find(option => option.value === this.conditions.filters[value]).title
    },
    getCountryTitle () {
      if (!this.country) {
        return ''
      }
      return { competitiveness: this.country.country_name, attraction: this.country.partner_name, toolcompetitiveness: this.country.country_name, toolattraction: this.country.partner_name }[this.analysisType]
    },
    async downloadGraph () {
      let url = await html2DataUrl(this.$refs.chartField, 'png', 0.3)
      let title = ''
      title = title + {
        country: {
          competitiveness: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '的市場競爭力',
          attraction: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '各國市場吸引力',
          toolcompetitiveness: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '的農業機械市場競爭力',
          toolattraction: this.getFilterTitle('year') + '年' + this.getFilterTitle('product') + '各國農業機械市場吸引力'
        },
        year: {
          competitiveness: this.getCountryTitle() + '的' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '市場的歷年市場競爭力',
          attraction: this.getFilterTitle('product') + '在' + this.getCountryTitle() + '的歷年市場吸引力',
          toolcompetitiveness: this.getCountryTitle() + '的' + this.getFilterTitle('product') + '在' + this.getFilterTitle('country') + '市場的歷年農業機械市場競爭力',
          toolattraction: this.getFilterTitle('product') + '在' + this.getCountryTitle() + '的歷年農業機械市場吸引力'
        }
      }[this.dataType][this.analysisType]
      title = title + this.typeOptions[0].options.find(option => option.value === this.graphType).title + '.png'
      await this.sendGraphAccessLog()
      downloadFile(title, url, '_blank')
    },
    async sendGraphAccessLog () {
      try {
        let config = this.$ls.get('userInfo')
        const accessFileTypeMap = {
          scatter: 'xy_scatter_diagram',
          bubble: 'bubble_chart',
          bar: 'cumulative_bar_graph',
          radar: 'radar_chart'
        }
        let type = {
          country: {
            competitiveness: 'market_competitiveness',
            attraction: 'market_attractiveness',
            toolcompetitiveness: 'market_competitiveness',
            toolattraction: 'market_attractiveness'
          },
          year: {
            competitiveness: 'single_country_market_competitiveness',
            attraction: 'single_country_market_attractiveness',
            toolcompetitiveness: 'single_country_market_competitiveness',
            toolattraction: 'single_country_market_attractiveness'
          }
        }[this.dataType][this.analysisType]
        let selectedDatas = this.selectedDatas.map(data => ({
          country: {
            competitiveness: data.country_name,
            attraction: data.partner_name,
            toolcompetitiveness: data.country_name,
            toolattraction: data.partner_name
          },
          year: {
            competitiveness: data.year,
            attraction: data.year,
            toolcompetitiveness: data.year,
            toolattraction: data.year
          }
        }[this.dataType][this.analysisType]))
        let paramDatas = {
          country: this.dataType === 'country' ? {
            competitiveness: {
              access_file_type: accessFileTypeMap[this.graphType],
              partner: this.conditions.filters.country,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            attraction: {
              access_file_type: accessFileTypeMap[this.graphType],
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            toolcompetitiveness: {
              access_file_type: accessFileTypeMap[this.graphType],
              partner: this.conditions.filters.country,
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            },
            toolattraction: {
              access_file_type: accessFileTypeMap[this.graphType],
              year: this.conditions.filters.year,
              product_code: this.conditions.filters.product
            }
          } : {},
          year: this.dataType === 'year' ? {
            competitiveness: {
              access_file_type: accessFileTypeMap[this.graphType],
              partner: this.conditions.filters.country,
              product_code: this.conditions.filters.product,
              country: this.country.country_code
            },
            attraction: {
              access_file_type: accessFileTypeMap[this.graphType],
              partner: this.country.partner_code,
              product_code: this.conditions.filters.product
            },
            toolcompetitiveness: {
              access_file_type: accessFileTypeMap[this.graphType],
              partner: this.conditions.filters.country,
              product_code: this.conditions.filters.product,
              country: this.country.country_code
            },
            toolattraction: {
              access_file_type: accessFileTypeMap[this.graphType],
              partner: this.country.partner_code,
              product_code: this.conditions.filters.product
            }
          } : {}
        }[this.dataType][this.analysisType]
        let paramInfos = {
          scatter: this.graphType === 'scatter' ? [
            [
              'x',
              this.conditions.weightings[this.filterConditions.xAxis].title,
              this.conditions.weightings[this.filterConditions.xAxis].active ? this.conditions.weightings[this.filterConditions.xAxis].value : 0
            ],
            [
              'y',
              this.conditions.weightings[this.filterConditions.yAxis].title,
              this.conditions.weightings[this.filterConditions.yAxis].active ? this.conditions.weightings[this.filterConditions.yAxis].value : 0
            ]
          ] : [],
          bubble: this.graphType === 'bubble' ? [
            [
              'x',
              this.conditions.weightings[this.filterConditions.xAxis].title,
              this.conditions.weightings[this.filterConditions.xAxis].active ? this.conditions.weightings[this.filterConditions.xAxis].value : 0
            ],
            [
              'y',
              this.conditions.weightings[this.filterConditions.yAxis].title,
              this.conditions.weightings[this.filterConditions.yAxis].active ? this.conditions.weightings[this.filterConditions.yAxis].value : 0
            ],
            [
              'z',
              this.conditions.weightings[this.filterConditions.point].title,
              this.conditions.weightings[this.filterConditions.point].active ? this.conditions.weightings[this.filterConditions.point].value : 0
            ]
          ] : [],
          bar: this.graphType === 'bar' ? (this.filterConditions.yAxis || []).map(value => [
            this.conditions.weightings[value].title,
            this.conditions.weightings[value].active ? this.conditions.weightings[value].value : 0
          ]) : [],
          radar: this.graphType === 'radar' ? (this.filterConditions.dimension || []).map(value => [
            this.conditions.weightings[value].title,
            this.conditions.weightings[value].active ? this.conditions.weightings[value].value : 0
          ]) : []
        }[this.graphType]
        let data = {
          ...paramDatas,
          chart_params_info: selectedDatas.join(', '),
          weighted_index_info: paramInfos.map(info => info.join(' = ')).join(', ')
        }
        await postAccessLog(type, data, config)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    filterOnChange (conditions) {
      if (JSON.stringify(conditions) !== JSON.stringify(this.filterConditions)) {
        this.filterConditions = conditions
        this.displayGraphType = this.graphType
        this.graphInit = conditions
      }
    }
  }
}
</script>

<style>
.echarts {
  width: 100% !important;
  height: 600px !important;
  min-height: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/graph.vue